/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface PatientsPatientPracticeConsentPermissions { 
    add: boolean;
    change: boolean;
    destroy: boolean;
    view: boolean;
}
export const PatientsPatientPracticeConsentPermissions_add_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientsPatientPracticeConsentPermissions_change_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientsPatientPracticeConsentPermissions_destroy_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientsPatientPracticeConsentPermissions_view_Validators: ValidatorFn[] =
    [  Validators.required, ];


